export const PROPERTY = 'Property';
export const CLIENT = 'Client';
export const UNIT = 'Unit';
export const LEASE = 'Lease';
export const HEADLEASE = 'Headlease';
